module.exports = __webpack_public_path__ + "static/media/447568547_452806424011993_3852688710409455276_n.94feb090.jpg";